import { useState } from 'react';
import PropTypes from 'prop-types';
import RoleTableRow from './RoleTableRow';
import CloseIcon from '../../../assets/icons/close.svg?react';

const UserRoleUpdateSideModal = ({ 
  user, 
  roles, 
  roleFeatureMap, 
  onClose, 
  onSave, 
  onToggleRole 
}) => {
  const [isSaving, setIsSaving] = useState(false);

  if (!user) return null;

  const handleSave = async () => {
    setIsSaving(true);
    try {
      await onSave();
    } catch (error) {
      // 에러는 부모에서 처리
      console.error('저장 실패:', error);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="side-modal-background" onClick={onClose}>
      <div className="side-modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="side-modal-header">
          <h3 className="text-h3 text-gray-900">사용자 역할 수정</h3>
          <button 
            className="side-modal-close"
            onClick={onClose}
          >
            <CloseIcon />
          </button>
        </div>
        
        <div className="side-modal-content">
          <div className="flex flex-col gap-5 mb-10">
            <p className="text-b2-700 text-gray-600">이메일</p>
            <p className="text-b2-400 text-gray-800">{user.email}</p>
          </div>

          <div className="flex flex-col gap-5 flex-1">
            <p className="text-b2-700 text-gray-800">역할 선택</p>
            <p className="form-hint text-b2-400 text-gray-600">
              사용자에게 부여할 역할을 선택하세요. (복수 선택 가능)
            </p>
            <p className="form-hint text-b2-400 text-gray-600 mb-10">
              User 역할은 해제할 수 없습니다.
            </p>
            <div className="primary-table role-selection-table">
              <table>
                <thead>
                  <tr>
                    <th width="30px"></th>
                    <th>역할</th>
                    <th>피처</th>
                    <th width="30px"></th>
                  </tr>
                </thead>
                <tbody>
                  {roles.map(role => (
                    <RoleTableRow
                      key={role}
                      role={role}
                      isChecked={user.roles.includes(role)}
                      featureCount={roleFeatureMap[role]?.length || 0}
                      features={roleFeatureMap[role]}
                      onToggle={() => onToggleRole(role)}
                    />
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="flex w-full mt-10">
            <button 
              className="btn py-5 px-10 big-btn btn-primary flex-1"
              onClick={handleSave}
              disabled={isSaving}
            >
              {isSaving ? '저장 중...' : '저장'}
            </button>
          </div>
        </div>

      </div>
    </div>
  );
};

UserRoleUpdateSideModal.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number.isRequired,
    email: PropTypes.string.isRequired,
    roles: PropTypes.arrayOf(PropTypes.string).isRequired,
  }),
  roles: PropTypes.arrayOf(PropTypes.string).isRequired,
  roleFeatureMap: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onToggleRole: PropTypes.func.isRequired,
};

export default UserRoleUpdateSideModal;
